<div class="flex pos-teclas-alpha">
  <div class="pb-1 ">
    <div [class.alpha-key-active]="!alphaKeysActive">
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="q"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="w"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="e"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="r"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="t"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="y"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="u"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="i"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="o"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="p"></button>
    </div>

    <div [class.alpha-key-active]="!alphaKeysActive">
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="a"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="s"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="d"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="f"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="g"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="h"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="j"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="k"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="l"></button>
      <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="ç"></button>
    </div>

    <div [class.symbol-key-active]="!symbolKeysActive">

      <button class="pos-btn-tecla" appKeyboardKey="/" ></button>
      <button class="pos-btn-tecla" appKeyboardKey="!"></button>
      <button class="pos-btn-tecla" appKeyboardKey=":"></button>
      <button class="pos-btn-tecla" appKeyboardKey=";"></button>
      <button class="pos-btn-tecla" appKeyboardKey="("></button>
      <button class="pos-btn-tecla" appKeyboardKey=")"></button>
      <button class="pos-btn-tecla" appKeyboardKey="$"></button>
      <button class="pos-btn-tecla" appKeyboardKey="&"></button>
      <button class="pos-btn-tecla" appKeyboardKey="@"></button>
      <button class="pos-btn-tecla" appKeyboardKey="?"></button>
      <button class="pos-btn-tecla" appKeyboardKey="="></button>
    </div>


    <div [class.symbol-key-active]="!symbolKeysActive">
      <button class="pos-btn-tecla" appKeyboardKey="_"></button>
      <button class="pos-btn-tecla" appKeyboardKey="\"></button>
      <button class="pos-btn-tecla" appKeyboardKey="|"></button>
      <button class="pos-btn-tecla" appKeyboardKey="~"></button>
      <button class="pos-btn-tecla" appKeyboardKey="["></button>
      <button class="pos-btn-tecla" appKeyboardKey="]"></button>
      <button class="pos-btn-tecla" appKeyboardKey="{"></button>
      <button class="pos-btn-tecla" appKeyboardKey="}"></button>
      <button class="pos-btn-tecla" appKeyboardKey="#"></button>
      <button class="pos-btn-tecla" appKeyboardKey="%"></button>
      <button class="pos-btn-tecla" appKeyboardKey="´"></button>
    </div>

    <div>
      <button class="pos-btn-tecla bg-secondary" (click)="capsActive = !capsActive"
              >{{ capsActive ? '#+=' : '⬆️'}}</button>

  <span [class.alpha-key-active]="!alphaKeysActive">
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="z"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="x"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="c"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="v"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="b"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="n"></button>
    <button class="pos-btn-tecla" [capsActive]="capsActive" [class.uppercase]="capsActive" appKeyboardKey="m"></button>
  </span>

    <span [class.symbol-key-active]="!symbolKeysActive">
       <button class="pos-btn-tecla" appKeyboardKey="&lt;"></button>
      <button class="pos-btn-tecla" appKeyboardKey="&gt;"></button>
       <button class="pos-btn-tecla" appKeyboardKey="&pound;"></button>
      <button class="pos-btn-tecla" appKeyboardKey="&yen;"></button>
      <button class="pos-btn-tecla" appKeyboardKey="&euro;"></button>
      <button class="pos-btn-tecla" appKeyboardKey="&quot;"></button>
      <button class="pos-btn-tecla" appKeyboardKey="'"></button>
      <button class="pos-btn-tecla" appKeyboardKey="`"></button>
    </span>

      <button class="pos-btn-del" (click)="onBackspace()">◀</button>
    </div>
    <div>
      <button class="pos-btn-tecla bg-secondary" (click)="mudarTeclas()">{{ symbolKeysActive ? 'ABC' : '!#1'}}</button>
      <button class="spacebar pos-btn-space" appKeyboardKey="&nbsp;"></button>
      <button class="pos-btn-shift"  (click)="capsActive = !capsActive">Shift</button>
    </div>
  </div>
  <div>
    <div>
      <div fxLayout="row nowrap" >
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="7"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="8"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="9"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="+"></button>
      </div>
      <div fxLayout="row nowrap" >
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="4"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="5"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="6"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="-"></button>
      </div>
      <div fxLayout="row nowrap" >
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="1"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="2"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="3"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="*"></button>
      </div>
      <div fxLayout="row nowrap" >
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="0"></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey=","></button>
        <button class="pos-btn-tecla" fxFlex="25" appKeyboardKey="."></button>
        <button class="pos-btn-tecla" fxFlex="25" (click)="onBackspace()" >
          <mat-icon style="font-size: large;">keyboard_backspace</mat-icon>
        </button>
      </div>
    </div>
  </div>

</div>
